<template>
    <div class='style-info'>
        <InfoTitle title='前景风格设置' />
        <Divider/>
        <LabelInput label='延迟出现（秒）' :time="true"/>
        <LabelInput label='显示时长（秒）' :time="true"/>
        <div class='button'>
            撤销风格
        </div>
    </div>
</template>

<script>
  import InfoTitle from "../base/InfoTitle";
  import Divider from '../base/Divider';
  import LabelInput from "../base/LabelInput";
  export default {
    name: "StyleInfo",
    components:{InfoTitle, Divider, LabelInput}
  }
</script>

<style scoped>
    .style-info{
        width:239px;
        height:850px;
        background:rgba(248,248,248,1);
        box-sizing: border-box;
        padding: 11px 13px 0 13px;
    }

    .button{
        width:89px;
        height:25px;
        background:rgba(255,255,255,1);
        border-radius:2px;
        border:1px solid rgba(229,229,231,1);
        font-size:12px;
        font-weight:500;
        color:rgba(101,102,103,1);
        line-height:25px;
        text-align: center;
        margin-top: 18px;
        cursor: pointer;
    }
</style>
